(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  // Handle click outside to close account menu
  document.addEventListener('click', (e) => {
    const accountMenus = document.querySelectorAll('.header__account-menu');
    accountMenus.forEach(menu => {
      if (menu.open && !menu.contains(e.target)) {
        menu.open = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["room-ideas"] && !Shopify.designMode) return;
  try {
    
/* Room ideas — client-side Room/Style filtering plus, in Grid layout, a
   row-track height synced to the live column width so the chosen cell shape
   holds at any column count. AND across both dropdowns; empty = "all". */
(function () {
  if (customElements.get('room-ideas')) return;

  class RoomIdeas extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-ri-grid]');
      this.cards = Array.from(this.querySelectorAll('[data-ri-card]'));
      this.selects = Array.from(this.querySelectorAll('[data-ri-filter]'));
      this.empty = this.querySelector('[data-ri-empty]');

      this.onChange = this.onChange.bind(this);
      this.syncRowHeight = this.syncRowHeight.bind(this);

      if (this.selects.length && this.cards.length) {
        this.selects.forEach((select) => select.addEventListener('change', this.onChange));
      }

      if (this.grid && this.grid.classList.contains('room-ideas__grid--grid')) {
        this.syncRowHeight();
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.syncRowHeight);
          this.ro.observe(this.grid);
        }
      }
    }

    disconnectedCallback() {
      this.selects.forEach((select) => select.removeEventListener('change', this.onChange));
      if (this.ro) this.ro.disconnect();
    }

    onChange() {
      const filters = {};
      this.selects.forEach((select) => {
        filters[select.dataset.riFilter] = select.value;
      });

      let visible = 0;

      this.cards.forEach((card) => {
        const roomOk = !filters.room || card.dataset.room === filters.room;
        const styleOk =
          !filters.style ||
          (card.dataset.styles || '').indexOf('|' + filters.style + '|') !== -1;

        const show = roomOk && styleOk;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (this.empty) this.empty.hidden = visible !== 0;
    }

    syncRowHeight() {
      const grid = this.grid;
      if (!grid) return;

      const styles = getComputedStyle(grid);
      const cols = parseInt(styles.getPropertyValue('--ri-cols'), 10);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const width = grid.clientWidth;

      if (!width || !cols || cols < 1) return;
      if (width === this._lastWidth && cols === this._lastCols) return;
      this._lastWidth = width;
      this._lastCols = cols;

      const ratio = parseFloat(grid.dataset.riRatio) || 1;
      const colWidth = (width - gap * (cols - 1)) / cols;
      if (colWidth <= 0) return;

      grid.style.setProperty('--ri-row-h', (colWidth / ratio).toFixed(2) + 'px');
    }
  }

  customElements.define('room-ideas', RoomIdeas);
})();

  } catch(e) { console.error(e); }
})();
})();
